import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatDivider } from "@angular/material/divider";

@Component({
  selector: 'app-table-column-menu-item-group',
  standalone: true,
  imports: [ MatDivider ],
  templateUrl: './table-column-menu-item-group.component.html',
  styleUrl: './table-column-menu-item-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableColumnMenuItemGroupComponent {
  public label: InputSignal<string | undefined> = input();
}
